var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item delete-btn",attrs:{"id":_vm.deleteButtonId},on:{"click":_vm.onClickDelete}},[_vm._v("\n    Delete\n")])}
var staticRenderFns = []

export { render, staticRenderFns }